var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button button-facebook button-icon button-icon-left button-round text-white",attrs:{"href":"#"},on:{"click":_vm.login}},[_c('span',{staticClass:"icon fa fa-facebook"}),_c('span',[_vm._v("Facebook")])])}
var staticRenderFns = []

export { render, staticRenderFns }